import { Component, Input } from '@angular/core';
import { Tile } from '@app/models/content';
import {TileContext, TileFormat} from "@app/shared/enums";

@Component({
  selector: 'app-tile-chronicle',
  templateUrl: './tile-chronicle.component.html',
  styleUrls: ['./tile-chronicle.component.scss']
})
export class TileChronicleComponent {

  @Input() tile: Tile;
  @Input() format: TileFormat;
  @Input() context: TileContext;

  constructor() { }
}
